import {YamlMenuFunzionalita} from "@model";
import {SIDE_MENU_CATEGORIES, SIDE_MENU_ITEM_TO_CATEGORIES} from "@constants";

export function generateSideMenuItems(menuConfigs: YamlMenuFunzionalita[]): Map<number, YamlMenuFunzionalita[]>{
  const sideMenuItems : Map<number, YamlMenuFunzionalita[]> = new Map<number, YamlMenuFunzionalita[]>();
  if (!menuConfigs?.length) return sideMenuItems;

  menuConfigs.forEach((item) => {
    const sideMenuGroupId = SIDE_MENU_ITEM_TO_CATEGORIES.get(item.id);
    if (sideMenuGroupId) {
      if (!sideMenuItems.has(sideMenuGroupId)) {
        sideMenuItems.set(sideMenuGroupId, []);
      }
      sideMenuItems.get(sideMenuGroupId)?.push(item);
    }

  })
  return sideMenuItems;
}


export function getSideMenuCategoryName(categoryId: number): string {
  return SIDE_MENU_CATEGORIES.get(categoryId) ?? 'Unknown Category';
}
